<stx-checkbox [formGroup]="formGroupReference" [controlName]="controlName">
  <ng-content></ng-content>
</stx-checkbox>
